import React from "react";
import { useLocation } from "react-router-dom";

import AutoGraphIcon from "@mui/icons-material/AutoGraph";
import FolderOpenOutlinedIcon from "@mui/icons-material/FolderOpenOutlined";
import GridViewOutlinedIcon from "@mui/icons-material/GridViewOutlined";
import TaskAltOutlinedIcon from "@mui/icons-material/TaskAltOutlined";
import { IconProps, Tab, Tabs } from "@mui/material";
import { useNavigate } from "hooks";
import { useClientIdSelector } from "store";

const iconStyles: IconProps["sx"] = { fontSize: "18px" };

const tabSx = {
  minHeight: "20px",
  maxHeight: "25px",
  padding: "0px",
  fontSize: "15px",
  color: "#5d7782",
  minWidth: "50px",
  marginLeft: "8px",
  marginRight: "8px",
  "&.Mui-selected": {
    color: "#071F35",
    fontWeight: 600
  }
} as const;

const tabsConfig = [
  {
    icon: <GridViewOutlinedIcon sx={iconStyles} />,
    label: "Overview",
    value: "Overview",
    route: "clientDashboard" as const,
    segment: "dashboard"
  },
  {
    icon: <FolderOpenOutlinedIcon sx={iconStyles} />,
    label: "Workspace",
    value: "Workspace",
    route: "clientWorkspace" as const,
    segment: "workspace"
  },
  {
    icon: <AutoGraphIcon sx={iconStyles} />,
    label: "Report",
    value: "Report",
    route: "clientReporting" as const,
    segment: "report"
  },
  {
    icon: <FolderOpenOutlinedIcon sx={iconStyles} />,
    label: "Entities",
    value: "Entities",
    route: "clientEntities" as const,
    segment: "entities"
  },
  {
    icon: <TaskAltOutlinedIcon sx={iconStyles} />,
    label: "Task Manager",
    value: "TaskManager",
    route: "clientTasks" as const,
    segment: "tasks"
  }
];

export const NavBarHorizontal: React.FC = () => {
  const clientId = useClientIdSelector() ?? null;
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const activeTab = tabsConfig.find((tab) => pathname.includes(`/${tab.segment}`));

  return (
    <Tabs value={activeTab?.value ?? false} sx={{ minHeight: "25px", maxHeight: "25px" }}>
      {tabsConfig.map((tab) => (
        <Tab
          key={tab.value}
          icon={tab.icon}
          label={tab.label}
          value={tab.value}
          iconPosition="start"
          sx={tabSx}
          onClick={() => {
            if (clientId) {
              navigate({ route: tab.route, params: { client_id: clientId } });
            }
          }}
        />
      ))}
    </Tabs>
  );
};
